// Wrapper to access Vite environment variables.
// This module is mocked in Jest to avoid import.meta parsing issues.
// @ts-ignore - import.meta.env is provided by Vite
export const viteEnv = import.meta.env
